"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateSubmissionCountForCheckpoint(state) {
    state.submissionCount = state.submissions.length;
    state.reAttemptCount = Math.max(0, state.submissions.length - 1);
}
exports.updateSubmissionCountForCheckpoint = updateSubmissionCountForCheckpoint;
//# sourceMappingURL=updateSubmissionCountForCheckpoint.js.map